<script>
  import { envConfig } from '../../../store'
  import TgIcon from './assets/icon.svg'

  const url = $envConfig.tgLink

</script>

<a href={url} target="_blank">{@html TgIcon}</a>
